import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled, { createGlobalStyle } from "styled-components";
import { getPoemsEvent, getStoriesExplore } from "./utilities/ApiCalls";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import Constant from "./Constant";
import ProfileImage from "../Componets/ProfileImage";
import SindhiFontWoff2 from "../fonts/SHREE-DEV7-0714.woff2";
import SindhiFontWoff from "../fonts/SHREE-DEV7-0714.woff";

const SindhiFontStyles = createGlobalStyle`
  @font-face {
    font-family: 'SHREE-DEV7-0714';
    src:
      url(${SindhiFontWoff2}) format('woff2'),
      url(${SindhiFontWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const Explore = () => {
  const [t] = useTranslation();
  const [stories, setstories] = useState();
  const [poetries, setpoetries] = useState();
  const [slide, setslide] = useState();
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const Stories = () => {
    getStoriesExplore().then((response) => {
      // console.log(response.data);
      setstories(response.data);
    });
  };

  const Poetries = () => {
    getPoemsEvent().then((response) => {
      // console.log(response.data);
      setpoetries(response.data);
    });
  };

  useEffect(() => {
    Stories();
    Poetries();
  }, []);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowSize.width < 600) {
      setslide(4);
    } else {
      setslide(9);
    }
  }, [windowSize.width]);

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com")) return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  const timeAgo = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}D AGO`;
    if (hours > 0) return `${hours}H AGO`;
    if (minutes > 0) return `${minutes}M AGO`;
    return "JUST NOW";
  };

  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    // Strip HTML tags
    const plainText = text.replace(/<[^>]+>/g, "");
    if (plainText.length <= maxLength) return plainText;
    return plainText.substring(0, maxLength) + "...";
  };

  return (
    <Layout>
      <Root>
        <SindhiFontStyles />
        <ExploreHeader>
          <div className="header-content">
            <div className="curated-label">CURATED SELECTION</div>
            <h1 className="collection-title">The Collection</h1>
            <p className="collection-description">
              A library of human experiences. Dive into stories, poetry, and
              memoirs from creators around the globe.
            </p>
          </div>
        </ExploreHeader>
        <div className="explore-container">
          <div className="section-container">
            <h1 className="Heading">{t("Explore.Stories")}</h1>
            <div className="grid-container">
              {stories &&
                stories.length > 0 &&
                stories.slice(0, slide).map((data) => {
                  const isSindhiStory =
                    (data.language || "").toLowerCase() === "sindhi";

                  return (
                    <Link
                      key={data._id}
                      to={`/story-details/${data._id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="cart">
                        <div className="author-info">
                          <ProfileImage
                            src={data.profilePic || data.user?.profilePic}
                            name={data.authorName || data.user?.name || "Author"}
                            size={40}
                            className="author-avatar"
                            alt={data.authorName || data.user?.name || "Author"}
                            proxiedUrl={proxiedUrl}
                            imgStyle={{
                              border: "1px solid var(--color-border)",
                              background: "var(--color-background)",
                            }}
                          />
                          <span className="author-name">
                            {data.authorName || data.user?.name || "Unknown"}
                          </span>
                        </div>
                        <div
                          className="title"
                          style={
                            isSindhiStory
                              ? {
                                  fontFamily: "SHREE-DEV7-0714",
                                  fontSize: "16px",
                                }
                              : undefined
                          }
                        >
                          {data.name}
                        </div>
                        {(data.description || data.story) && (
                          <div
                            className={`story-snippet${
                              isSindhiStory ? " sindhi-text" : ""
                            }`}
                            dangerouslySetInnerHTML={{
                              __html: truncateText(
                                data.description || data.story,
                                150
                              ),
                            }}
                          ></div>
                        )}
                      </div>
                    </Link>
                  );
                })}
            </div>
            <Link style={{ width: "100%" }} to={`/stories`}>
              <div className="Explore">{t("Explore.ExploreLoad")}</div>
            </Link>
          </div>

          <div className="section-container">
            <h1 className="Heading">{t("Explore.Poetries")}</h1>
            <div className="grid-container">
              {poetries &&
                poetries.length > 0 &&
                poetries.slice(0, slide).map((data) => {
                  const isSindhiPoem =
                    (data.language || "").toLowerCase() === "sindhi";

                  return (
                    <Link
                      key={data._id}
                      to={`/poem-details/${data._id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="cart">
                        <div className="author-info">
                          <ProfileImage
                            src={data.profilePic || data.user?.profilePic}
                            name={data.authorName || data.user?.name || "Author"}
                            size={40}
                            className="author-avatar"
                            alt={data.authorName || data.user?.name || "Author"}
                            proxiedUrl={proxiedUrl}
                            imgStyle={{
                              border: "1px solid var(--color-border)",
                              background: "var(--color-background)",
                            }}
                          />
                          <span className="author-name">
                            {data.authorName || data.user?.name || "Unknown"}
                          </span>
                        </div>
                        <div
                          className="title"
                          style={
                            isSindhiPoem
                              ? {
                                  fontFamily: "SHREE-DEV7-0714",
                                  fontSize: "16px",
                                }
                              : undefined
                          }
                        >
                          {data.name}
                        </div>
                        {(data.description || data.story) && (
                          <div
                            className={`story-snippet${
                              isSindhiPoem ? " sindhi-text" : ""
                            }`}
                            dangerouslySetInnerHTML={{
                              __html: truncateText(
                                data.description || data.story,
                                150
                              ),
                            }}
                          ></div>
                        )}
                      </div>
                    </Link>
                  );
                })}
            </div>
            <Link style={{ width: "100%" }} to={`/poetries`}>
              <div className="Explore">{t("Explore.ExploreLoad")}</div>
            </Link>
          </div>
        </div>
      </Root>
    </Layout>
  );
};

export default Explore;

const ExploreHeader = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px 10px;
  min-height: 180px;

  .header-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: fit-content;
    max-width: 90%;
    padding: 20px 30px;
    background-color: var(--color-background);
  }

  .curated-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: var(--color-text);
    margin-bottom: 12px;
    font-family: sans-serif;
  }

  .collection-title {
    font-size: 32px;
    font-weight: 400;
    color: var(--color-text-tertiary);
    margin: 0 0 16px 0;
    font-family: "Merriweather", serif;
    line-height: 1.2;
    white-space: nowrap;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .collection-description {
    font-size: 14px;
    font-weight: 400;
    color: var(--color-text-tertiary);
    margin: 0;
    max-width: 450px;
    line-height: 1.5;
    font-family: "Merriweather", serif;

    @media (max-width: 768px) {
      font-size: 13px;
      max-width: 350px;
    }
  }
`;

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: "Merriweather", serif;
  padding-bottom: 40px;

  .explore-container {
    width: 100%;
    max-width: 1200px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;

    @media (max-width: 768px) {
      padding: 40px 8px;
    }
  }

  .section-container {
    width: 100%;
    margin-bottom: 60px;
  }

  .Heading {
    font-size: 32px;
    margin-bottom: 20px;
    font-weight: 700;
    color: var(--color-primary);
    text-align: left;
    width: 100%;
    padding-left: 10px;
    font-family: "Merriweather", serif;
    letter-spacing: -0.5px;
  }

  .Explore {
    text-align: center;
    font-style: italic;
    color: var(--color-text-tertiary);
    margin-top: 30px;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    transition: all 0.2s ease;
    text-decoration: none;

    &:hover {
      color: var(--color-primary);
      transform: translateY(-2px);
    }
  }

  /* Grid Layout - 3 columns on desktop, 2 columns on mobile */
  .grid-container {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding: 10px 10px;
    background-color: var(--color-raw-porcelain);

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      padding: 5px 4px;
    }
  }

  /* Card Styles - Matching Reference UI */
  .cart {
    width: 100%;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    padding: 24px;
    transition: transform 0.3s ease, box-shadow 0.3s ease,
      border-color 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    text-align: left;
    color: var(--color-text-tertiary);

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      border-color: var(--color-primary);
    }
  }

  .author-info {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }

  .author-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--color-border);
    background: var(--color-background);
  }

  .author-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-text-tertiary);
    font-family: sans-serif;
  }

  .title {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text-tertiary);
    margin: 0;
    line-height: 1.3;
    font-family: "Merriweather", serif;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--color-border);
  }

  .story-snippet {
    font-size: 14px;
    line-height: 1.6;
    color: var(--color-text-tertiary);
    font-family: "Merriweather", serif;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: left;

    /* Drop cap styling for first letter */
    &::first-letter {
      float: left;
      font-size: 48px;
      line-height: 0.7;
      padding-right: 8px;
      padding-top: 4px;
      font-weight: 400;
      font-style: italic;
      color: var(--color-text-tertiary);
    }

    /* Remove default paragraph margins and styling */
    p {
      margin: 0;
      display: inline;
    }
  }

  .story-snippet.sindhi-text,
  .story-snippet.sindhi-text p,
  .story-snippet.sindhi-text strong,
  .story-snippet.sindhi-text em,
  .story-snippet.sindhi-text u {
    font-family: "SHREE-DEV7-0714", "Merriweather", serif;
    font-size: 16px;
  }
`;
